import styled from "styled-components";

import { Item } from "./Item";
import { Section, Heading } from "./Section";
import { Content } from "./Content";
import { Wrapper } from "./Wrapper";
import { Link } from "./Link";

import {
    breakpoints,
    Div as SharedDiv,
    colors,
    easingSeconds
} from "../shared";

const ProfileMenuDesktop = styled.nav`
    position: absolute;
    right: 0;
    width: 100vw;
    z-index: 100;
    text-align: right;

    ${Section} {
        margin-right: 6.25rem;

        &:last-of-type {
            margin-right: 3.75rem;
        }
    }

    ${Wrapper} {
        position: relative;
        top: 2.5rem;
    }

    @media (max-width: ${breakpoints.lg}rem) {
        display: none;
    }
`;

const Div = styled(SharedDiv)`
    ${Link} {
        transition: all ${easingSeconds};
    }

    ${({ isHeroSearchV2 }) =>
        isHeroSearchV2 &&
        `

        ${Heading} {
            color: ${colors.darkTwo};
        }

        ${Link} {
            &,
            &:visited {
                color: ${colors.brownishGrey};
            }

            &:hover {
                color: ${colors.darkTwo};
                text-decoration: underline;
            }
        }

        // for ProfileMenu Desktop links when isHeroSearchV2:
        .scrolledDown  & {
            ${Link} {
                color: ${colors.whiteDuplicate};
                &:hover {
                    color: ${colors.veryLightPinkTwo};
                }
            }
        }

        .scrolledUp  & {
            ${Link} {
                color: ${colors.brownishGrey};
                &:hover {
                    color: ${colors.darkTwo};
                }
            }
        }

    `}
`;

export {
    ProfileMenuDesktop,
    Wrapper,
    Item,
    Heading,
    Section,
    Content,
    Link,
    Div
};
